import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { XInfoLabel, XMediaFn } from '@/components/xqxc_ui';
import model from '@/reducers/system/operation/model';
import { XTitle } from '@/components/xqxc_ui';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const BaseInfo = ({
    setBreadcrumbPaths,
    match,
    getSystemOperationInfo,
    systemOperationInfo: {
        companyAuditOpinion,
        companyBaseInfo: {
            companyId = '',
            companyName = '',
            principalName = '',
            statusName = '',
            provinceName = '',
            cityName = '',
            contactTel = '',
            address = '',
            agrtStartTime = '',
            agrtEndTime = '',
            companyAttachPact = ''
        } = {},
        loginName = '',
    } = {}
}) => {

    const container = {
        width: '100%',
        height: '100%',
        padding: '20px'
    };

    const infoStyle = {
        paddingLeft: '20px'
    };

    useEffect(() => {
        getSystemOperationInfo();
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);

    return <div style={container}>
        <XTitle style={{ marginBottom: '10px' }} label='基本信息' />
        <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='运营公司编号：' value={companyId} />
                <XInfoLabel style={infoStyle} label='运营公司名称：' value={companyName} />
                <XInfoLabel style={infoStyle} label='负责人：' value={principalName} />
            </Col>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='状态：' value={statusName} />
                <XInfoLabel style={infoStyle} label='省份/城市：'
                    value={`${provinceName ? provinceName : ''}${cityName ? cityName : ''}`} />
                <XInfoLabel style={infoStyle} label='联系电话：' value={contactTel} />
            </Col>
            <Col span={8}>
                <XInfoLabel style={infoStyle} label='管理用户名：' value={loginName} />
                <XInfoLabel style={infoStyle} label='详细地址：' value={address} />
            </Col>
            <Col span={24}>
                <XInfoLabel style={infoStyle} label='审核意见：' value={companyAuditOpinion} />
            </Col>
            <Col span={24}>
                <XInfoLabel style={infoStyle} label='协议有效期：'
                    value={`${agrtStartTime ? moment(agrtStartTime).format('YYYY-MM-DD') : ''} ${(agrtStartTime && agrtEndTime) ? '至' : ''} ${agrtEndTime ? moment(agrtEndTime).format('YYYY-MM-DD') : ''}`} />
            </Col>
            <Col span={24}>
                <div style={{ display: 'flex', marginTop: '10px', ...infoStyle }}>
                    <p style={{ color: '#999999' }}>协议：</p>
                    <XMediaFn dataSource={companyAttachPact} />
                </div>
            </Col>
        </Row>
    </div>;
};

BaseInfo.propTypes = {
    getSystemOperationInfo: PropTypes.func,
    systemOperationInfo: PropTypes.object,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect((state) => ({
    systemOperationInfo: state.systemOperation.systemOperationInfo,
}), {
    setBreadcrumbPaths,
    ...model.actions
})(BaseInfo);
